/* global axios */
import ApiClient from '../ApiClient';

class CaptainDocument extends ApiClient {
  constructor() {
    super('captain/documents', { accountScoped: true });
  }

  get({ page = 1, searchKey, assistantId, teamId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
        assistant_id: assistantId,
        team_id: teamId,
      },
    });
  }

  reprocess(documentId) {
    return axios.post(`${this.url}/${documentId}/reprocess`);
  }

  regenerateFaqs(documentId) {
    return axios.post(`${this.url}/${documentId}/regenerate_faqs`);
  }

  changeTeam(documentId, teamId) {
    return axios.put(`${this.url}/${documentId}`, {
      document: { team_id: teamId },
    });
  }

  rename(documentId, name) {
    return axios.put(`${this.url}/${documentId}`, {
      document: { name },
    });
  }

  destroyFailed() {
    return axios.delete(`${this.url}/destroy_failed`);
  }
}

export default new CaptainDocument();
